import Service from "../../../Services/index";

const Material = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
        material_all : [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        search:{
            code: "",
            type : ""
        },
        factorial_material_list : []
    },
    mutations: {
        REPLACE_MATERIAL: (state, res) => {
            state.replace_data = res;
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                code: "",
                type : ""
            }
        },
        //วัสดุอุปกรณ์โรงงาน
        FACTORIAL_MATERIAL : (state,res)=>{
            state.factorial_material_list = res.data
        },
    },
    actions: {
        get({ commit },page=1) {
            return Service.material.getMaterial(page);
        },
        show({ commit }, id) {
            return Service.material.showMaterial(id).then(response => {
                commit("REPLACE_MATERIAL", response);
            });
        },
        create({ commit }, data) {
            return Service.material.createMaterial(data);
        },
        update({ commit }, { id, data }) {
            return Service.material.updateMaterial(id, data);
        },
        delete({ commit }, {id,user_id}) {
            return Service.material.deleteMaterial(id,user_id);
        },
        active({ commit }, {id,user_id}) {
            return Service.material.activeMaterial(id,user_id);
        },
        search({ commit }, {page=1,data}) {
            return Service.material.searchMaterial(page,data);
        },
        getAll({commit}){
            return Service.material.getMaterialAll();
        },
        addMeterial({commit},data){
            return Service.material.addMeterial(data);
        },
        addPack({commit},data){
            return Service.material.addPack(data);
        },
        deletePack({commit},data){
            return Service.material.deletePack(data);
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        //วัสดุอุปกรณ์โรงงาน
        getFactorialMaterial({commit}){
            return Service.material.getFactorialMaterial().then(response=>{
                commit("FACTORIAL_MATERIAL",response)
            })
        },
        saveMaterialType({commit},data){
            if(data.id){
                return Service.material.updateMaterialType(data);
            }else{
                return Service.material.createMaterialType(data);
            }
        }
    }
};
export default Material;
